/**
 * Typed multipart fields for `POST /api/upload/image`.
 * When `eventId` is set, `purpose` is required (`album` | `cover`).
 */

import {
  EVENT_MEDIA_PURPOSE_ALBUM,
  EVENT_MEDIA_PURPOSE_COVER,
} from "@/lib/events/event-media-purpose"

export const EVENT_IMAGE_UPLOAD_PURPOSE_FIELD = "purpose" as const

/** Gallery upload (photos & videos) — does not change persisted event cover. */
export function uploadEventAlbumImageFormData(
  eventId: string,
  file: File,
  /** Optional decoded pixel size (e.g. from `readImageFilePixelSize`) — stored for layout-stable viewers. */
  pixelSize?: { width: number; height: number } | null,
  opts?: {
    uploadSessionId?: string
  },
): FormData {
  const fd = new FormData()
  fd.set("file", file)
  fd.set("eventId", eventId)
  fd.set(EVENT_IMAGE_UPLOAD_PURPOSE_FIELD, EVENT_MEDIA_PURPOSE_ALBUM)
  if (
    pixelSize &&
    pixelSize.width > 0 &&
    pixelSize.height > 0 &&
    Number.isInteger(pixelSize.width) &&
    Number.isInteger(pixelSize.height)
  ) {
    fd.set("imagePixelWidth", String(pixelSize.width))
    fd.set("imagePixelHeight", String(pixelSize.height))
  }
  if (opts?.uploadSessionId?.trim()) {
    fd.set("uploadSessionId", opts.uploadSessionId.trim())
  }
  return fd
}

/** Host-only explicit cover change — updates `Event.image` / `images` and creates `Media` with purpose `cover`. */
export function uploadEventCoverImageFormData(
  eventId: string,
  file: File,
  pixelSize?: { width: number; height: number } | null,
): FormData {
  const fd = new FormData()
  fd.set("file", file)
  fd.set("eventId", eventId)
  fd.set(EVENT_IMAGE_UPLOAD_PURPOSE_FIELD, EVENT_MEDIA_PURPOSE_COVER)
  if (
    pixelSize &&
    pixelSize.width > 0 &&
    pixelSize.height > 0 &&
    Number.isInteger(pixelSize.width) &&
    Number.isInteger(pixelSize.height)
  ) {
    fd.set("imagePixelWidth", String(pixelSize.width))
    fd.set("imagePixelHeight", String(pixelSize.height))
  }
  return fd
}
